import { combineReducers } from 'redux'

import { estadoSilosReducer } from './estadoSilos'

export const movimientosReducer = combineReducers({
  estadoSilos: estadoSilosReducer
})
